import { render, staticRenderFns } from "./SearchSwitcher.vue?vue&type=template&id=4395e102"
import script from "./SearchSwitcher.vue?vue&type=script&lang=js"
export * from "./SearchSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports